import { appMode } from "../shared/constants/AppConst";

// Default fallback URLs for different environments
const DEV_SERVER_URL = "https://ooa-webapp-backend.openxcell.dev/";
const STAGING_SERVER_URL = "https://cms-backend-stg.o-orthodontics.academy";
const LOCAL_SERVER_URL = "http://localhost:8001";

// add cases for all 3 envs
export const server =
  process.env.REACT_APP_API_URL ||
  (appMode === "staging" ? STAGING_SERVER_URL : appMode === "development" ? DEV_SERVER_URL : LOCAL_SERVER_URL);